import { init } from '@amplitude/analytics-browser'
import { AMPLITUDE_KEY } from 'src/app/config'

export function setupAmplitude() {
  if (!AMPLITUDE_KEY) return
  init(AMPLITUDE_KEY, {
    fetchRemoteConfig: true,
    autocapture: {
      attribution: false,
      pageViews: false,
      sessions: true,
      formInteractions: false,
      fileDownloads: false,
      elementInteractions: false,
    },
  })
}
